import React, { Component } from "react";
import { Link } from "react-router-dom";
import { loading } from "../components/CustomComponent.js";
import { Btn } from "../components/ui.js";
import { MascotBot } from "../components/illustrations.js";

/* LEVELUP ONE — สมัครสมาชิก (Register / Early adopter) */
export default class Register extends Component {
  state = { name: "", email: "", password: "", agree: false, error: "", done: false };
  componentDidMount() { loading(false); window.scrollTo(0, 0); }

  submit = (e) => {
    e.preventDefault();
    const { name, email, password, agree } = this.state;
    if (!name.trim()) return this.setState({ error: "กรุณากรอกชื่อ" });
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.setState({ error: "กรุณากรอกอีเมลให้ถูกต้อง" });
    if (password.length < 6) return this.setState({ error: "รหัสผ่านอย่างน้อย 6 ตัวอักษร" });
    if (!agree) return this.setState({ error: "กรุณายอมรับเงื่อนไขการใช้งาน" });
    this.setState({ error: "", done: true });
  };

  render() {
    const { name, email, password, agree, error, done } = this.state;
    return (
      <div className="nx">
        <div className="nx-auth">
          <aside className="nx-auth__aside">
            <Link to="/" className="nx-brand" style={{ color: "#fff" }}>
              <span className="nx-brand__mark" style={{ background: "rgba(255,255,255,0.2)" }}>L</span>
              <span className="nx-brand__name" style={{ color: "#fff" }}>LevelUp One</span>
            </Link>
            <div style={{ marginTop: 40 }}>
              <MascotBot style={{ width: 130, height: "auto" }} />
              <h2 className="mt-3">เริ่มต้นใช้งานฟรี</h2>
              <p>สมัครเป็น Early Adopter วันนี้ รับสิทธิ์ทดลองใช้ฟรี 30 วัน</p>
              <ul className="nx-auth__points">
                <li>ทดลองใช้ฟรี ไม่ต้องผูกบัตร</li>
                <li>ทีมงานช่วยตั้งค่าให้ตั้งแต่เริ่ม</li>
                <li>ยกเลิกได้ทุกเมื่อ</li>
              </ul>
            </div>
          </aside>

          <main className="nx-auth__main">
            <div className="nx-auth__card">
              {done ? (
                <div className="text-center">
                  <div style={{ fontSize: "3rem" }}>🎉</div>
                  <h1 className="nx-ink mt-2">สมัครสำเร็จ!</h1>
                  <p className="nx-muted mb-4">ขอบคุณคุณ {name} — นี่เป็นเดโม UI ทีมงานจะติดต่อกลับเพื่อเริ่มใช้งาน</p>
                  <Btn to="/">ไปหน้าแรก</Btn>
                </div>
              ) : (
                <>
                  <h1 className="nx-ink">สมัครสมาชิก</h1>
                  <p className="nx-muted mb-4">มีบัญชีอยู่แล้ว? <Link to="/login" className="nx-primary">เข้าสู่ระบบ</Link></p>
                  <form onSubmit={this.submit} noValidate>
                    <div className="nx-field">
                      <label className="nx-label">ชื่อ-นามสกุล</label>
                      <input className="nx-input" value={name} placeholder="ชื่อของคุณ"
                        onChange={(e) => this.setState({ name: e.target.value, error: "" })} />
                    </div>
                    <div className="nx-field">
                      <label className="nx-label">อีเมล</label>
                      <input className="nx-input" type="email" value={email} placeholder="you@email.com"
                        onChange={(e) => this.setState({ email: e.target.value, error: "" })} />
                    </div>
                    <div className="nx-field">
                      <label className="nx-label">รหัสผ่าน</label>
                      <input className="nx-input" type="password" value={password} placeholder="อย่างน้อย 6 ตัวอักษร"
                        onChange={(e) => this.setState({ password: e.target.value, error: "" })} />
                    </div>
                    <label className="d-flex align-items-center gap-2 mb-3" style={{ fontSize: "0.9rem", cursor: "pointer" }}>
                      <input type="checkbox" checked={agree} onChange={(e) => this.setState({ agree: e.target.checked, error: "" })} />
                      ยอมรับ <Link to="/" className="nx-primary">เงื่อนไขการใช้งาน</Link>
                    </label>
                    {error && <p className="text-danger" style={{ fontSize: "0.88rem" }}>{error}</p>}
                    <button type="submit" className="nx-btn nx-btn--primary nx-btn--block">สมัครสมาชิก</button>
                  </form>
                  <p className="text-center mt-4"><Link to="/" className="nx-muted" style={{ fontSize: "0.9rem" }}>← กลับหน้าแรก</Link></p>
                </>
              )}
            </div>
          </main>
        </div>
      </div>
    );
  }
}
